import * as React from 'react'
import { Typography, Box, Breadcrumbs, Link } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import { AdminConfirmationForm } from '../../../forms/AdminConfirmationForm'
import axios from 'axios'
import { ErrorAlert } from '../../../alerts/ErrorAlert'
import { axiosErrorHandling } from '../../../misc/other'


export const AdminConfirmAccounts = () =>{


let data = JSON.parse(window.localStorage.getItem('usercontext'))



const [userData, setUserData] = React.useState(data)
const [error, setError] = React.useState(false)
const [errorMessage, setErrorMessage] = React.useState('')

const closeError = ()=>{
    setError(false)
}

React.useEffect(()=>{
    let datatocheck = JSON.parse(window.localStorage.getItem('usercontext'))
    
    if(!Object.hasOwn(datatocheck, 'wave_customer_number')){
        
        axios({method: "POST",
             url:  '/api/oracle2/getwaveid',
             data: {email: datatocheck.email}
      }).then( async result=>{
          
          
          let waveID = await result.data.waveID
          datatocheck.wave_customer_number = waveID
          window.localStorage.setItem('usercontext', JSON.stringify(datatocheck))
          return datatocheck
      }).catch(err=>{
            let errMessage = axiosErrorHandling(err)
            setErrorMessage(errMessage)
            setError(true)
      })
          }

        
        setUserData(datatocheck)
          
    
},[])





return(
    <Box sx={{minHeight:'80vh', mt: 15, mb: 2}}>
    <Breadcrumbs>
        <Link underline='hover' component={RouterLink} to='../dashboard'>Dashboard</Link> 
        <Link underline='hover' component={RouterLink} to='../customercare'>Search </Link> 
    </Breadcrumbs>
    <ErrorAlert error={errorMessage} open={error} handleClose={closeError}/>    
    <Typography align='center' variant='h6'sx={{mb: .5}} > Please Confirm The Following Information with the Customer: </Typography>
    <Typography align='center' variant='h6' sx={{mb: 3}}>Customer Number: {data.customer_number}</Typography>
    <AdminConfirmationForm data={userData}/>
    </Box>
)
}